<script setup lang="ts">
//import { profileDD } from '@/_mockApis/headerData';
import defaultUserImage from "@/assets/images/profile/user-1.jpg";
import { i18nGlobal } from "@/i18n";
import { routesName } from "@/plugins/router";
import { useStoreUser } from "@/stores/storeUser";
import type { profileType } from "@/types/HeaderTypes";
import { isEmptyCheckLocal } from "@/utils/utils";
const { t } = useI18n();
const profileDD: profileType[] = [
  {
    title: i18nGlobal.t("menu.settings.accountSettings"),
    href: routesName.accountSettings,
    badge: false,
  },
  {
    title: i18nGlobal.t("menu.settings.logout"),
    href: routesName.logout,
    badge: false,
  },
  /*{
        title: 'My Subscription',
        href: '/pages/pricing',
        badge:false
    },
    {
        title: 'My Notes',
        href: '/apps/notes',
        badge:true
    },*/
];

const userStore = useStoreUser();

const userImage = computed(() => {
  return !isEmptyCheckLocal(userStore.userData?.imageUrl)
    ? userStore.userData?.imageUrl
    : defaultUserImage;
});
</script>

<template>
  <!-- ---------------------------------------------- -->
  <!-- notifications DD -->
  <!-- ---------------------------------------------- -->
  <v-menu open-on-hover open-on-click>
    <template v-slot:activator="{ props }">
      <v-btn
        variant="text"
        class="custom-hover-primary"
        color="primary"
        v-bind="props"
        icon
      >
        <v-avatar size="35">
          <img :src="userImage" width="35" />
        </v-avatar>
      </v-btn>
    </template>
    <v-sheet rounded="md" elevation="10">
      <div class="pa-6">
        <div class="d-flex align-center pb-6">
          <v-avatar size="55">
            <img :src="userImage" width="55" />
          </v-avatar>
          <div class="ml-3">
            <div>
              <h6 class="text-subtitle-1">
                {{ userStore.userData.displayName }}
              </h6>
              <span class="text-success text-caption">{{
                t("user.roleDescription." + userStore.getRole)
              }}</span>
            </div>
            <span class="text-subtitle-1 textSecondary mt-4">{{
              userStore.userData.email
            }}</span>
          </div>
        </div>
        <v-divider></v-divider>
        <perfect-scrollbar>
          <v-list class="py-0 theme-list mt-3" lines="one">
            <v-list-item
              v-for="item in profileDD"
              :key="item.title"
              class="py-0 px-2 rounded-md custom-text-primary"
              color="primary"
              :to="item.href"
            >
              <div class="d-flex gap-3 align-center">
                <p class="text-subtitle-1 heading custom-title">{{ item.title }}</p>
                <v-chip size="small" color="error" v-if="item.badge">4</v-chip>
              </div>
            </v-list-item>
          </v-list>
        </perfect-scrollbar>
      </div>
    </v-sheet>
  </v-menu>
</template>
